import Vue from 'vue'
import Router from 'vue-router'
// import official   from '@/components/OfficialwebPc' 
import recharge from '@/page/webpage/recharge.vue'

import h5recharge from '@/page/h5page/h5recharge.vue'
// import jointwork  from '@/components/jointwork'
// import phone      from '@/components/phone'
Vue.use(Router)

export default new Router({
  routes: [

    {
      path: '/recharge',
      name: 'recharge',
      title: "充值",
      component: recharge
    },

    {
      path: '/h5recharge',
      name: 'h5recharge',
      title: "账户充值",
      component: h5recharge
    },

    // {path:'/phone',component:phone}
  ],
  scrollBehavior(to, from, savedPosition) {

    if (savedPosition) {
      return savedPosition
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js